import { render, staticRenderFns } from "./DrawingCanvas.vue?vue&type=template&id=490b6060&"
import script from "./DrawingCanvas.vue?vue&type=script&lang=js&"
export * from "./DrawingCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports